import BaseEntity from "@/core/misc/BaseEntity";
import DateSimple from "@/core/types/DateSimple";
import CurrencyRate from "@/core/types/CurrencyRate";

/**
 * Опции для toString валюты.
 *
 *   format — что показывать:
 *     'code'   — буквенный код (RUB, USD). По умолчанию.
 *     'symbol' — символ валюты (₽, $).
 */
type CurrencyToStringOptions = {
  format?: 'code' | 'symbol';
};

class Currency extends BaseEntity {
  /** Цифровой код валюты согласно ISO 4217 */
  //id: number;

  /** Буквенный код валюты согласно ISO 4217 */
  code: string;

  /** Описание валюты */
  description: string;

  /** Символ валюты */
  symbol: string;

  /** Минимальный объем для расчета наличными */
  min?: number;

  /** Значимое количество знаков после запятой
   * ПРИМЕЧАНИЕ: при округлении можно использовать ТОЛЬКО как fallback-значение
   */
  decimals?: number;

  /** Курс валюты */
  rate: CurrencyRate;

  /** Дата курса валюты */
  rateDate?: DateSimple;

  static fromServer(serverData: any, result = new Currency()): Currency {
    super.fromServer(serverData, result);

    // Курс — Numeric-тип, автомат не подхватывает. Гидрируем напрямую, без
    // хелпера hydrate: он тянет Core, а Currency грузится на этапе инициализации
    // CurrenciesService (до готовности Core) — вышла бы циклическая зависимость.
    if (serverData.rate === null || serverData.rate === undefined) {
      result.rate = null;
    }
    else {
      result.rate = CurrencyRate.fromServer(serverData.rate);
    }

    // с сервера не передается (во всяком случае пока)
    result.rateDate = new DateSimple();

    return result;
  }

  /***
   * По умолчанию — буквенный код (RUB, USD). Через options.format можно
   * переключить на символ (₽, $).
   *
   * Примеры:
   *   currency.toString()                     → "RUB"
   *   currency.toString({ format: 'symbol' }) → "₽"
   */
  toString(options: CurrencyToStringOptions = {}): string {
    const format = options.format ?? 'code';

    if (format === 'symbol') {
      return this.symbol;
    }
    else {
      return this.code;
    }
  }

  static initRubDefault(): Currency {
    return Currency.fromServer({
      "id": 643,
      "code": "RUB",
      "description": "Российский рубль",
      "symbol": "₽",
      "min": 0.01,
      "decimals": 2,
      "rate": null
    })
  }
}

export default Currency;
export type { CurrencyToStringOptions };
